import axios from 'axios';
import notification from './notifications';
import store from '../store';
import { findDeepProp } from '../plugins/helpers';
import Qs from 'qs';

const serverNotRespondingMessage = (status) => {
  return `Our server is not responding (${status}), please try again later,
if the problem persists call the system administrator.`;
};

const axiosPlugin = {};
const headers = {
  'Cache-control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': 0,
};

// Program all Axios defaults here
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT || '';
axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'indices' });
axios.defaults.headers.common = headers;

axiosPlugin.request = (config) => {
  store.commit('setDoingAjax', true);

  // If the store is holding a "Token" we will sent the token to the API as part of a
  // Authorization HEADER.

  if (store.state.auth.isAuthenticated
    && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${store.getters['auth/token']}`;
  }

  return config;
};

axiosPlugin.requestError = (error) => {
  store.commit('setDoingAjax', false);
  return Promise.reject(error);
};

axiosPlugin.response = (response) => {
  store.commit('setDoingAjax', false);
  return response;
};

axiosPlugin.responseError = (error) => {
  /**
   * Display some global messages here
   */
  store.commit('setDoingAjax', false);
  
  if (error.response) {
    // Authorization error, log the user out!
    if ([ 403, 401 ].indexOf(error.response.status) !== -1) {
      // User not authorized, log it out.
      const endpoint = String(error.response.config.url).split('/').pop();
      // TODO: Add all authentication and reset password endpoints
      const byPass = [ 'me', 'logout', 'login', 'confirm-email', 'reset-password', 'EmailConfirmation', 'validate-token', 'start-reset-password', 'authenticate' ];
      if (!byPass.includes(endpoint)) {
        store.dispatch('phillyAccount/msalSignOut');
        return;
      }
    }
  }

  // We got to the end of this, something really odd happened and no notification was displayed to the user.
  error.unnotified = true;
  return Promise.reject(error);
};

/**
 * SETTING UP SOME INTERCEPTORS FOR NUXT
 */
// Add a request interceptor
axios.interceptors.request.use(axiosPlugin.request, axiosPlugin.requestError);
// Add a response interceptor
axios.interceptors.response.use(axiosPlugin.response, axiosPlugin.responseError);


// Error controller
const defaultResponseController = (error, renderFatal) => {

  // If a list of errors is found, we join them and then display the result.
  const dataErrors = findDeepProp('response.data.errors', error);
  if (dataErrors !== null) {
    if (Object.keys(dataErrors).length > 0) {
      let errors = '';
      for (let field in dataErrors) {
        errors += `${dataErrors[field].join("\n")},`;
      }
      notification.warning(errors.slice(0, -1), { duration: 10000 });
      return;
    }
  }

  // if a message is found, we display it.
  const dataMessage = findDeepProp('response.data.message', error);
  if (typeof dataMessage === 'string') {
    notification.warning(dataMessage);
    return;
  } 

  // Ignore (for now) status code 404
  const dataStatus = findDeepProp('response.status', error);
  if (dataStatus === 404) {
    const method = findDeepProp('response.config.method', error);
    if ([ 'post', 'put' ].indexOf(method) !== -1) {
      notification.error(serverNotRespondingMessage(dataStatus));
    }
    return;
  }

  // Server error for status codes 500+
  if (dataStatus >= 500) {
    notification.error(serverNotRespondingMessage(dataStatus));
    return;
  }

  if (renderFatal) {
    notification.fatalError();
  }

  console.error(error);

  return;
};

// AIS axios
const aisAxios = axios.create({
  baseURL: process.env.VUE_APP_AIS_ROOT || '',
});

// Carto axios
const cartoAxios = axios.create({
  baseURL: process.env.VUE_APP_CARTO_ROOT || '',
  headers: {},
});

cartoAxios.defaults.headers.common = {};

export default {
  install: (Vue, { store }) => {
    Vue.prototype.$axios = axios;
    Vue.prototype.$aisAxios = aisAxios;
    Vue.prototype.$cartoAxios = cartoAxios;
    Vue.prototype.$defaultResponseController = defaultResponseController;

    store.$axios = axios;
    store.$aisAxios = aisAxios;
    store.$cartoAxios = cartoAxios;
    store.$defaultResponseController = defaultResponseController;

    // Vue.axios = axios;
  },
};